import { IonCard, IonCardTitle } from "@ionic/react";
import { useEffect } from "react";
import { makePOSTRequest } from "../../request/rawRequest";

interface IMarkProps {
  mark: number;
  _id: string;
}

const getColor = (mark: number) => {
  if (mark <= 10) {
    return "#B0102F";
  } else if (mark <= 14) {
    return "#FC6902";
  } else {
    return "#7BE382";
  }
};

const Mark: React.FC<IMarkProps> = ({ mark, _id }) => {
  const color = getColor(mark);

  useEffect(() => {
    makePOSTRequest("/mark", {
      id_thing: _id,
      mark,
      type: "quizz",
    });
  }, []);

  return (
    <div>
      <IonCard
        style={{
          border: "thick solid " + color,
        }}
      >
        <IonCardTitle>
          <div
            style={{
              textAlign: "center",
              margin: 10,
            }}
          >
            Vous avez eu {mark}/20 à ce quiz.
          </div>
        </IonCardTitle>
      </IonCard>
    </div>
  );
};

export default Mark;
